import React, { useState } from 'react';
import './HeaderStripSection.css';
import { useScreenWidthLessHook } from '../../../../shared/src/hooks/use-screen-width-less.hook';

export const HeaderStripSection = ({
    mainImageUrl,
    backgroundImageUrl,
    title,
    description,
    colors = {},
}) => {
    const [isMobileView, setIsMobileView] = useState(null);
    useScreenWidthLessHook({
        setIsWindowWidthLess: setIsMobileView
    });
    const sectionStyleVariables = {
        '--title-color': colors?.title,
        '--text-color': colors?.text,
        '--divider-color': colors?.divider,
    };

    if (!isMobileView) {
        sectionStyleVariables.backgroundImage = `url('${backgroundImageUrl}')`;
    }

    return <div
        className="loyalty-header-strip"
        style={sectionStyleVariables}
    >
        <div className="loyalty-header-strip__content">
            <div className="loyalty-header-strip__image">
                <img alt="" src={mainImageUrl}/>
            </div>
            <div className="loyalty-header-strip__divider"></div>
            <div className="loyalty-header-strip__text">
                <h1 className="loyalty-header-strip__title">{title}</h1>
                <p className="loyalty-header-strip__description">{description}</p>
            </div>
        </div>
    </div>;
};
